import axios from 'axios'

export default {
    searchClusters (page = 1, labels = [], subcategories = [], paginationSize = 15) {
        return axios.post('/api/home/clusters', {
            labels: labels,
            subcategories: subcategories,
            page: page,
            pagination_size: paginationSize
        })
    },
    getHomeHeaderSection () {
        return axios.get('/api/home-sections/header')
    },
    getLocal(local) {
        return axios.get('/locale/'+ local)
    }
}
